/* Avirelle · Sale-Teaser (v28, 03.10.2026) – wählt pro Seitenaufruf EIN Motiv zufällig (kein Wechsel während des Besuchs)
   und stellt seinen Bildmittelpunkt (fx/fy aus dem Theme-Editor) in die Fläche.
   v50 (05.10.2026): Das Laufband bewegt dieses Skript (zweiter Block unten), damit man es am Handy wischen kann. */
(function () {
  function init(root) {
    if (root.pslOk) return; root.pslOk = true;
    var f = root.querySelector('[data-psl-flaeche]');
    var tpl = [].slice.call(root.querySelectorAll('template[data-psl-motiv]'));
    if (!f || !tpl.length) return;
    var t = tpl[Math.floor(Math.random() * tpl.length)];
    f.appendChild(t.content.cloneNode(true));
    f.style.setProperty('--fx', (t.getAttribute('data-fx') || 50) + '%');
    f.style.setProperty('--fy', (t.getAttribute('data-fy') || 50) + '%');
    var u = t.getAttribute('data-url');
    f.href = u;
    var a = root.querySelector('[data-psl-stueck]'); if (a) a.href = u;
  }
  function alle() { [].forEach.call(document.querySelectorAll('[data-psl-root]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
  document.addEventListener('shopify:section:load', alle);   // Theme-Editor
})();

/* v50 · Sale-Laufband zum Wischen (Prototyp sale-wischen, von Holger am iPhone freigegeben 05.10.2026)
   Läuft von selbst; Finger/Trackpad übernimmt; nach dem Loslassen 3 s Pause, dann weiter ab dort.
   Endlos: die Karten liegen dreifach hintereinander, die Position wird unbemerkt ins mittlere Drittel zurückgesetzt. */
(function () {
  var PAUSE = 3000, DAUER = 70;
  function init(lauf) {
    if (lauf.pslWisch) return; lauf.pslWisch = true;
    var spur = lauf.querySelector('.psl-lauf__spur');
    var kopie = spur && spur.querySelector('.psl-lauf__kopie');
    if (!kopie) return;
    var noch = kopie.cloneNode(true);
    spur.appendChild(noch);
    lauf.classList.add('psl-lauf--wisch');
    var karten = spur.querySelectorAll('.psl-karte');
    var n = karten.length / 3;
    var W = 0, pos = 0, soll = -1, letzt = 0, finger = false, maus = false, nutzer = 0;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function mass() {
      W = karten[n].offsetLeft - karten[0].offsetLeft;
    }
    function mitte() {
      if (W <= 0) return;
      var s = lauf.scrollLeft;
      if (s < W * 0.5) s += W; else if (s >= W * 1.5) s -= W;
      if (s !== lauf.scrollLeft) { soll = Math.round(s); lauf.scrollLeft = s; }
      pos = lauf.scrollLeft;
    }
    function start() {
      var alt = W; mass();
      if (alt <= 0 && W > 0) { soll = Math.round(W); lauf.scrollLeft = W; pos = W; }
    }
    start();
    document.addEventListener('avirelle:css', start);
    lauf.addEventListener('scroll', function () {
      if (Math.abs(lauf.scrollLeft - soll) > 2) { nutzer = Date.now(); pos = lauf.scrollLeft; }
    }, { passive: true });
    lauf.addEventListener('touchstart', function () { finger = true; nutzer = Date.now(); }, { passive: true });
    lauf.addEventListener('touchend', function () { finger = false; nutzer = Date.now(); }, { passive: true });
    lauf.addEventListener('touchcancel', function () { finger = false; nutzer = Date.now(); }, { passive: true });
    lauf.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') maus = true; });
    lauf.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') maus = false; });
    window.addEventListener('resize', function () { if (W > 0) { mass(); mitte(); } });
    function schritt(t) {
      var dt = letzt ? Math.min((t - letzt) / 1000, 0.1) : 0;
      letzt = t;
      if (W <= 0) start();
      var ruhig = Date.now() - nutzer > PAUSE;
      if (!finger && ruhig) {
        if (Math.abs(lauf.scrollLeft - pos) > 2) pos = lauf.scrollLeft;
        if (pos < W * 0.5 || pos >= W * 1.5) { mitte(); }
        if (!maus && !still && W > 0) {
          pos += W / DAUER * dt;
          soll = Math.round(pos);
          lauf.scrollLeft = pos;
        }
      }
      requestAnimationFrame(schritt);
    }
    requestAnimationFrame(schritt);
  }
  function alle() { [].forEach.call(document.querySelectorAll('.psl-lauf'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
  document.addEventListener('shopify:section:load', alle);
})();
